<template>
    <page-table/>
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-awsReport-salesList',
  components: {
    PageTable,
  },
}
</script>